<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import _ from "lodash";

export default {
  page: {
    title: "Log Aksi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = [];

    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Username",
        name: "username",
      },
      {
        width: "auto",
        label: "Menu",
        name: "menu",
      },
      {
        width: "auto",
        label: "Tipe Aktifitas",
        name: "type",
      },
      {
        width: "25%",
        label: "Url",
        name: "url",
      },
      {
        width: "150px",
        label: "Waktu Aktifitas",
        name: "date",
      },
      {
        width: "100px",
        label: "Aksi",
        name: "aksi",
      },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Log Aksi",
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "date",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "date",
        dir: "desc",
        username: "",
        menu: "",
        type: "",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      showModal: false,
      loadingModal: false,
      modalData: [],
    };
  },
  async mounted() {
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    await this.getDataTable();
  },
  methods: {
    fullDateTimeFormat(datetime) {
      return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
    },
    async getDataTable(resetPage = true) {
      this.loadingTable = true;

      let payload = { ...this.tableFilter };

      if (resetPage) {
        this.tableFilter.page = 1;
      }

      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "log/action",
        params: payload,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data.data.data;
            this.configPagination(response_data.data);
            this.currentTablePage = response_data.data.current_page;
            this.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.data.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage: function (url) {
      let link = new URLSearchParams(url.split("?")[1] || "");
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },
    exportData() {
      const params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        `${process.env.VUE_APP_BACKEND_URL_VERSION}export-excel/log-action?${params}`,
        "_blank"
      );
    },
    async showDetail(log_id) {
      this.showModal = true;
      this.loadingModal = true;
      this.modalData = { data_before: null, data_after: null };

      axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + `log/action/${log_id}`,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      })
        .then((response) => {
          let response_data = response.data;
          console.log({response_data});
          if (response_data.meta.code == 200) {
            this.modalData = response_data.data?.log_aksi_detail ?? [];
            this.loadingModal = false;
          } else {
            this.showModal = false;
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.data.message,
            });
          }
        })
        .catch((errors) => {
          this.showModal = false;
          console.log(errors);
        });
    },
    closeModal() {
      this.showModal = false;
    },
    objectToTable(data) {
      if (data === null || data === undefined || typeof data !== 'string' || data.trim() === '') {
        return null;
      }

      let firstParse;
      try {
        firstParse = JSON.parse(data); // This should unwrap the outer quotes and un-escape.
      } catch (e) {
        // If the first parse fails, it's not the format we expect.
        console.error("Failed first JSON parse:", e);
        return null;
      }

      if (typeof firstParse !== 'string') {
          // It might be that the data is only single-encoded.
          // If so, firstParse is already the object.
          if (typeof firstParse === 'object' && firstParse !== null) {
              const entries = Object.entries(firstParse);
              return entries.length > 0 ? entries : null;
          }
          return null;
      }
      
      let secondParse;
      try {
        secondParse = JSON.parse(firstParse); // This should parse the inner JSON string.
      } catch (e) {
        console.error("Failed second JSON parse:", e);
        return null;
      }

      if (typeof secondParse !== 'object' || secondParse === null) {
        return null;
      }

      const entries = Object.entries(secondParse);
      return entries.length > 0 ? entries : null;
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="card-title">Log Aksi</div>
              </div>
              <div class="col-md-6">
                <div class="text-end">
                  <button class="btn btn-sm btn-success" @click="exportData">
                    <i class="fa fa-file-excel"></i> Export Excel
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div class="form-group col-md-3">
                    <label for="filterUsername">Username</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Username"
                      v-model="tableFilter.username"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="filterMenu">Menu</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Menu"
                      v-model="tableFilter.menu"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-3">
                    <label for="filterType">Type</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Filter Type"
                      v-model="tableFilter.type"
                      @input="filterData"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            style="width: 100%"
                            v-model="tableFilter.per_page"
                            @change="getDataTable()"
                          >
                            <option value="10" selected>10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </td>
                        <td>Entries</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-md-5">&nbsp;</div>
                  <div class="col-md-3">
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Cari Data ..."
                      v-model="tableFilter.search"
                      @input="getDataTable()"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive mb-0">
                <datatable
                  :columns="columns"
                  :sortKey="sortKey"
                  :sortOrders="sortOrders"
                  @sort="sortBy"
                >
                  <tbody>
                    <tr v-if="loadingTable">
                      <td colspan="99" class="text-center">
                        <i class="fas fa-spinner fa-spin"></i> Loading...
                      </td>
                    </tr>
                    <tr v-else-if="table_data.length === 0">
                      <td class="text-center" colspan="99">
                        Data Tidak Tersedia
                      </td>
                    </tr>
                    <tr
                      v-else
                      v-for="(row_data, key_data) in table_data"
                      :key="key_data"
                    >
                      <td class="text-center">
                        {{ pagination.from + key_data }}
                      </td>
                      <td>
                        {{ row_data.username }}
                      </td>
                      <td>
                        {{ row_data.menu }}
                      </td>
                      <td>
                        {{ row_data.type }}
                      </td>
                      <td>
                        {{ row_data.url }}
                      </td>
                      <td class="text-center">
                        {{ fullDateTimeFormat(row_data.date) }}
                      </td>
                      <td class="text-center">
                        <button class="btn btn-sm btn-primary" @click="showDetail(row_data.log_aksi_id)">
                          <i class="fa fa-eye"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </datatable>
              </div>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" :class="{ 'show': showModal }" :style="{ 'display': showModal ? 'block' : 'none' }" tabindex="-1" role="dialog" @click.self="closeModal">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Detail Log Aksi</h5>
            <button type="button" class="close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loadingModal" class="text-center">
              <i class="fas fa-spinner fa-spin"></i> Loading...
            </div>
            <div v-else>
              <div v-if="!modalData || modalData.length === 0">
                <p>No details available for this log entry.</p>
              </div>
              <!-- Loop over each detail entry -->
              <div v-for="(detail, index) in modalData" :key="detail.log_aksi_detail_id" class="log-detail-item">
                <h5 v-if="modalData.length > 1">Detail #{{ index + 1 }}</h5>
                <div class="row">
                  <!-- Data Before -->
                  <div class="col-md-6">
                    <h6>Data Sebelum</h6>
                    <div class="table-responsive">
                      <table class="table table-bordered table-striped table-sm detail-table" v-if="objectToTable(detail.data_before)">
                        <thead class="table-light">
                          <tr>
                            <th style="width: 30%;">Key</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="([key, value], i) in objectToTable(detail.data_before)" :key="'before-' + i">
                            <td>{{ key }}</td>
                            <td>
                              <pre v-if="typeof value === 'object' && value !== null"><code>{{ JSON.stringify(value, null, 2) }}</code></pre>
                              <span v-else>{{ value === null ? 'null' : value }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p v-else>No data before.</p>
                    </div>
                  </div>
                  <!-- Data After -->
                  <div class="col-md-6">
                    <h6>Data Sesudah</h6>
                    <div class="table-responsive">
                      <table class="table table-bordered table-striped table-sm detail-table" v-if="objectToTable(detail.data_after)">
                        <thead class="table-light">
                          <tr>
                            <th style="width: 30%;">Key</th>
                            <th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="([key, value], i) in objectToTable(detail.data_after)" :key="'after-' + i">
                            <td>{{ key }}</td>
                            <td>
                              <pre v-if="typeof value === 'object' && value !== null"><code>{{ JSON.stringify(value, null, 2) }}</code></pre>
                              <span v-else>{{ value === null ? 'null' : value }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <p v-else>No data after.</p>
                    </div>
                  </div>
                </div>
                <hr v-if="index < modalData.length - 1">
              </div>
            </div>
          </div>
          <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
          </div> -->
        </div>
      </div>
    </div>
    <div v-if="showModal" class="modal-backdrop fade show"></div>

  </Layout>
</template>

<style scoped>
.log-detail-item {
  margin-bottom: 1.5rem;
}
.detail-table td {
  word-break: break-word;
  vertical-align: top;
}
pre {
  white-space: pre-wrap;
  background-color: #f0f2f5;
  padding: 1rem;
  border-radius: 0.25rem;
  font-size: 12px;
  color: #212529;
}
code {
    font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>
